<template>
	<div>
		<MaterialText data-testid="customer-search-input" label="Search for customer" v-model="search" v-on:enter="update()" :disabled="saving" />

		<div data-testid="search-results" class="margin-top">
			<div v-for="result in results" v-on:click="pick(result)" class="clickable flex align-items small-margin-bottom">
				<Flag :localeid="result.locale.locale_id" />
				<div class="small-margin-left">
					{{ result.full_name }} ({{ result.id }})
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Vue from 'vue'

export default {
  props: [
    'value'
  ],
  data: () => ({
    search: '',
    saving: false,
    results: []
  }),
  computed: {
    customer: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  },
  methods: {
    pick (customer) {
      this.customer = customer
      this.results = []
      this.search = ''
    },
    update () {
      Vue.$api.get('/search/v2/customer?search=' + this.search, {}, {
        loader: toggle => this.saving = toggle,
        callback: data => this.results = data
      })
    }
  }
}
</script>
